<template>
  <div>
    <v-progress-linear v-if="cargando" indeterminate color="purple" class="mb-2" />

    <ag-grid-vue
      :gridOptions="gridOptions"
      class="ag-theme-balham ag-grid-listado-programas"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      @grid-ready="onGridReady"
      :rowData="items"
      rowSelection="single"
      colResizeDefault="shift"
      :animateRows="false"
      :floatingFilter="true"
      :pagination="false"
      :rowClassRules="rowClassRules"
      @selection-changed="onSelectionChanged"
      @first-data-rendered="onFirstDataRendered"
      :alwaysShowVerticalScroll="true"
      :suppressPaginationPanel="true"
      :pinnedBottomRowData="pinnedBottomRowData">
    </ag-grid-vue>
  </div>
</template>
  
<script>
import listadoAgGridMixin from '../mixins/listado-ag-grid.mixin';
import { FASES_PROGRAMA } from '../utils/constantes';
import { cellRendererNumeroRegistro } from '../utils/funciones';

export default {
  name: 'ListadoProgramas',
  mixins: [listadoAgGridMixin],
  computed: {
    pinnedBottomRowData() {
      return [
        {
          id: '',
          codigo: '',
          nombreCompuesto: 'Total Inscritos Universidad',
          cantidadInscritos: this.items.reduce((acc, item) => acc + Number(item.cantidadInscritos), 0),
          fase: '',
          sedeNombre: '',
          version: '',
          grupo: '',
          gestion: '',
        },
      ];
    },
  },
  data() {
    return {
      columnDefs: [
        {
          headerName: 'N° REGISTRO',
          cellRenderer: cellRendererNumeroRegistro,
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: false,
          minWidth: 130,
          maxWidth: 130,
        },
        {
          headerName: 'ID',
          field: 'id',
          filter: true,
          minWidth: 100,
          maxWidth: 100,
        },
        {
          headerName: 'CÓDIGO',
          field: 'codigo',
          minWidth: 150,
          maxWidth: 150,
        },
        {
          headerName: 'NOMBRE COMPUESTO',
          field: 'nombreCompuesto',
          minWidth: 400,
        },
        {
          headerName: 'CANTIDAD INSCRITOS UNIV.',
          field: 'cantidadInscritos',
          type: 'numericColumn',
          minWidth: 200,
          maxWidth: 200,
        },
        {
          headerName: 'FASE',
          field: 'fase',
          minWidth: 200,
          maxWidth: 200,
          valueGetter: (params) => {
            if (params.node.rowPinned) {
              return undefined;
            }

            return FASES_PROGRAMA[params.data.fase] || 'DESCONOCIDO';
          },
        },
        {
          headerName: 'SEDE',
          field: 'sedeNombre',
          minWidth: 200,
          maxWidth: 200,
        },
        {
          headerName: 'VERSIÓN',
          field: 'version',
          filter: false,
          minWidth: 100,
          maxWidth: 100,
        },
        {
          headerName: 'GRUPO',
          field: 'grupo',
          filter: false,
          minWidth: 100,
          maxWidth: 100,
        },
        {
          headerName: 'GESTIÓN',
          field: 'gestion',
          filter: false,
          minWidth: 100,
          maxWidth: 100,
        },
      ],
    };
  },
};
</script>
  
<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';

.ag-grid-listado-programas {
  height: calc(var(--vh, 1vh) * 100 - 24.5rem);
}
</style>
  